import { PostList } from 'module/Model/PostList';
import { WishEntity, identityEntity } from 'module/Redux/Common';
import { Wish } from 'module/Model/Wish';

export const postListEntity = WishEntity.createEntity<PostList>()(
  'PostList',
  identityEntity,
  Wish.createVoid('PostList Void')
);



// WEBPACK FOOTER //
// ./src/module/Redux/PostList/postListEntity.ts